import { gql } from "@apollo/client";

export const assistantChatMutation = gql`
    mutation assistantChat($input: AssistantChatInput!) {
        assistantChat(input: $input) {
            answer
            sources {
                id
                link
                relevanceScore
            }
        }
    }
`;
